import type { StatsResponse } from '../types/moderation';

interface AlertsBannerProps {
  stats: StatsResponse;
  onNavigate?: (hash: string) => void;
}

export default function AlertsBanner({ stats, onNavigate }: AlertsBannerProps) {
  const alerts: Array<{
    key: string;
    tone: 'error' | 'warning';
    message: string;
    ctaLabel: string;
    ctaHash: string;
  }> = [];

  if (stats.errorPipeline > 0) {
    alerts.push({
      key: 'pipeline',
      tone: 'error',
      message: `${stats.errorPipeline} submission${stats.errorPipeline === 1 ? '' : 's'} failed processing and need review.`,
      ctaLabel: 'View pipeline errors',
      ctaHash: '#/submissions?pipeline=error',
    });
  }

  if (stats.pending > 0) {
    alerts.push({
      key: 'pending',
      tone: 'warning',
      message: `${stats.pending} submission${stats.pending === 1 ? '' : 's'} awaiting moderation.`,
      ctaLabel: 'Review pending',
      ctaHash: '#/submissions?status=pending_review',
    });
  }

  if (alerts.length === 0) return null;

  return (
    <div className="alerts-banner" data-testid="alerts-banner">
      {alerts.map((alert) => (
        <div
          key={alert.key}
          className={`alert alert--${alert.tone}`}
          data-testid={`alert-${alert.key}`}
          role="alert"
        >
          <span className="alert__message">{alert.message}</span>
          <a
            href={alert.ctaHash}
            className="alert__cta"
            onClick={(e) => {
              if (onNavigate) {
                e.preventDefault();
                onNavigate(alert.ctaHash);
              }
            }}
          >
            {alert.ctaLabel}
          </a>
        </div>
      ))}
    </div>
  );
}
